import { application } from "./application"

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)
